export const contactDropdownId = 'contactDropdownId';
export const name = 'name';
export const phoneNumber = 'phoneNumber';
export const faxNumber = 'faxNumber';
export const email = 'email';
export const groups = 'groups';
export const groupName = 'groupName';
